// Import the functions you need from the SDKs you need

export const FirestoreDB = window.G_firebase_auth.IV_firestore_object;
